import { routes as nestedRoutes } from './:id'
import { routes as resourceRoutes } from './routes'

export const routes = {
  ...nestedRoutes,
  ...resourceRoutes,
}
